<template>
    <section>
        <div id="related-item" v-if="stripsItem" class="modal-mask" key="relatedItem">
            <div class="modal-wrapper _modalWrapper_">
                <div class="modal-container flexContainer">
                    <img src="../../assets/croix.png" width="20" height="20" alt="" @click="close();" class="cross fright abs pointer" />
                    <div class="modalBody">
                        <h2 class="ff-medium uppercase">
                            <!-- <span v-if="itemType === 'product'">Associer un module à un produit</span> -->
                            <!-- <span v-if="itemType === 'module'">Associer un produit à un module</span> -->
                        </h2>
                        <div id="selectContainer">
                            <multiselect
                                class="uppercase"
                                id="addRelatedItem"
                                v-model="value"
                                :options="options"
                                :multiple="true"
                                :preserve-search="true"
                                placeholder="Rechercher"
                                label="name"
                                track-by="name"
                                exact
                            >
                            </multiselect>
                        </div>
                        <div class="flexContainer jc-sb">
                            <button @click="close();" class="btn uppercase pointer ff-light">{{ $t("common.cancel") }}</button>
                            <button class="btn uppercase pointer ff-light" @click="saveRelatedItem();">{{ $t("common.save") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
//    import Vue from 'vue'
import "whatwg-fetch";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import httpService from "../../components/service";

export default {
    components: {
        multiselect: Multiselect
    },
    data() {
        return {
            brandList: [],
            showModal: true,
            swiperOption: {
                direction: "horizontal",
                loop: false,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: false,
                pagination: ".swiper-pagination",
                prevButton: ".swiper-button-prev",
                nextButton: ".swiper-button-next",
                paginationClickable: true,
                mousewheelControl: true,
                observeParents: true,
                debugger: true,
                slidesPerView: 1
            },
            camp: [],
            value: [],
            options: [],
            checkCategory: true,
            product: {},
            module: {},
            allRelatedItems: {}
        };
    },
    props: {
        stripsItem: {
            type: Boolean,
            requiered: true
        },
        itemType: {
            type: String,
            requiered: true
        }
    },
    watch: {
        "$route.params.id"(newId, oldId) {}
    },
    methods: {
        close() {
            this.$emit("closeModal", false);
            this.$emit("resetOption", "null");
        },
        saveRelatedItem() {
            let related = [];
            for (let i = 0; i < this.value.length; i++) {
                related.push(this.value[i].id);
            }
            let objectRelated = { components: related, type: "artwork" };
            httpService.put("/components/related/" + this.$route.params.id, JSON.stringify(objectRelated)).then(function(response) {
                if (response === "components related is ok") {
                    location.reload();
                }
            });
        },
        ticketStripsList() {
            httpService.get("/components?limit=20&categoryName=ticket-strip&type=4", JSON.stringify({})).then(response => {
                let option = [];
                this.options = [];
                for (let items of response.data) {
                    option[items.id] = items.terms.name[this.$t("trad")]["value"];
                }
                for (let j = 0; j < option.length; j++) {
                    if (option[j] !== undefined) {
                        // ??
                        this.options[j] = { id: j, name: option[j] };
                    }
                }
                this.$forceUpdate();
            });
        }
    },
    computed: {
        ...mapGetters({
            getTicketStrips: "items/getTicketStrips",
            getRelatedItems: "items/getRelatedItems",
            findRelatedTicketsStrip: "items/findRelatedTicketsStrip"
        })
    },
    created() {
        this.$store.dispatch("items/getTicketStrips", { id: this.$route.params.id }).then(() => {
            this.ticketStripsList();
        });
        this.$store.dispatch("items/findRelatedTicketsStrip", { id: this.$route.params.id }).then(() => {});
        for (let i = 0; i < this.findRelatedTicketsStrip.length; i++) {
            this.value[i] = {
                id: this.findRelatedTicketsStrip[i].id,
                name: this.findRelatedTicketsStrip[i].terms.name[this.$t("trad")]["value"]
            };
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

._selectedCampaign,
._selectedZone {
    color: #0000f0;
    @extend %primary-text;
    font-weight: bold;
}
/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}
/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 50px;
        right: 50px;
        z-index: 2;
    }
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            margin: auto;
            .brandWrap {
                padding: 5px;
            }
            p {
                font-family: Roboto;
                font-size: 18px;
            }
            .swiper-container-horizontal {
                .swiper-pagination {
                    margin-top: 10px;
                    position: initial;
                }
            }
            .swiper-button-prev {
                left: 25%;
                height: 15px;
            }
            .swiper-button-next {
                right: 25%;
                height: 15px;
            }
        }
    }
}
#zone {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}
#campaign {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}
#related-item {
    .modalBody {
        h2 {
            margin-top: 0px;
        }
        #selectContainer {
            margin-bottom: 30px;
        }
        width: 650px;
        min-height: 200px;
        @extend %second-bloc;
        border-radius: 4px;
        padding: 30px;
        #filterCategory {
            margin-top: 30px;
            margin-bottom: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// modalStrips.vue?6f7c44ac